import React from "react";
import Navbar from "./navbar";
import BottomBar from "./bottomBar";

export default function About() {
  return (
    <>
    <Navbar/>
    <div className="mt-52 mb-52">
      <div className="text-center">Coming Soon...</div>
    </div>
    <BottomBar/>
    </>
  );
}
